<div class="container single-view" id="add-repair">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr"></div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="repair-title" class="section-title">{{ 'REPAIR_ADD.TITLE' | translate }}</h1>
          <p data-testid="repair-subtitle" class="section-subtitle mt-1 text-base">{{ 'REPAIR_ADD.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form [formGroup]="repairItemFormGroup">
              <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-0 overflow-visible">
                <div class="row">
                  <div class="field-wr flex flex-col col-12 mt-2">
                    <section class="row">
                      <div class="col-12">
                        <h3 data-testid="repair-search-title" class="border-b pb-3 mt-0">{{ 'REPAIR_ADD.SEARCH' | translate }}</h3>
                      </div>
                      <label data-testid="serialnumber-label" class="block text-sm mb-2">
                        {{ 'REPAIR_ADD.SERIAL_NUMBER' | translate }} <i class="icon-required-field"></i>
                      </label>
                      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-5 col-lg-6 col-xl-4">
                        <div class="flex items-stretch camera-btn-field-wr">
                          <input data-testid="search" type="text" formControlName="serialNumber" autocomplete="off">
                          <textbox-camera data-testid="search-textboxcamera"class="shrink-0 self-stretch flex items-center" (qrCodeScanned)="qrCodeScanned($event)"></textbox-camera>
                        </div>
                      </div>
                      <div class="field-wr flex flex-col col-12 col-md-3">
                        <button data-testid="search-validate-btn" class="btn primary-btn" [disabled]="repairItemFormGroup.invalid"
                          (click)="searchSerialNumber()">
                          {{ 'WARRANTY_ACTIVATION.BTN_VALIDATE_SERIAL_NUMBER' | translate }}
                        </button>
                      </div>
                    </section>
                    @if (hasSubmittedSerialNumberSearch) {
                      <section class="row pb-4">
                        <div class="col-12">
                          <h3 data-testid="results" class="border-t pt-3">{{ 'REPAIR_ADD.RESULTS' | translate }}</h3>
                        </div>
                        @if (isSerialNumberValid) {
                          <div id="product-results">
                            <div class="product-item row mb-3">
                              <div class="col-12 col-sm-12 col-md-4 col-lg-3">
                                <img data-testid="product-imageurl" src="{{ item.productCustomisation?.imageUrl || item.product?.imageUrl || item.product?.productType?.imageUrl }}"
                                  class="w-100 mt-2 featured-image">
                              </div>
                              <div class="col-12 col-sm-12 col-md-8 col-lg-9">
                                <dl class="details-grid mt-3">
                                  <dt data-testid="productname-label" class="label grid-cols-1">{{ 'REPAIR_ADD.PRODUCT_NAME' | translate }}</dt>
                                  <dd data-testid="productname" class="value pb-3">{{ item.product.name }}</dd>
                                  <dt data-testid="sku-label" class="label grid-cols-1 pt-3">{{ 'REPAIR_ADD.SKU' | translate }}</dt>
                                  <dd data-testid="sku" class="value pt-3 pb-3">{{ item.product.sku }}</dd>
                                  <dt data-testid="collection-label" class="label grid-cols-1 pt-3">{{ 'REPAIR_ADD.COLLECTION' | translate }}</dt>
                                  <dd data-testid="collection" class="value pt-3 pb-3">
                                    @for (collection of item.product?.collections; track collection.id; let last = $last) {
                                      <a [routerLink]="['/collections/', collection.id]" class="inline-flex items-center link" target="_blank">{{ collection.name }}</a>@if (!last) {<span>, </span>}
                                    } @empty {
                                      {{ null | defaultValue }}
                                    }
                                  </dd>
                                  <dt data-testid="category-label" class="label grid-cols-1 pt-3">{{ 'REPAIR_ADD.CATEGORY' | translate }}</dt>
                                  <dd data-testid="category" class="value pt-3 pb-3">
                                    @for (category of item.product?.categories; track category.id; let last = $last) {
                                      <a [routerLink]="['/categories/', category.id]" class="inline-flex items-center link" target="_blank">{{ category.name }}</a>@if (!last) {<span>, </span>}
                                    } @empty {
                                      {{ null | defaultValue }}
                                    }
                                  </dd>
                                </dl>
                              </div>
                              <div class="row">
                                <div class="col-12">
                                  <h3 data-testid="repair-details" class="border-b pb-3">{{ 'REPAIR_ADD.REPAIR_DETAILS' | translate }}</h3>
                                </div>
                                <div class="row py-2" id="repair-details">
                                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                                    <label data-testid="retailer-label" class="block text-sm mb-1" for="retailerId">{{ 'REPAIR_ADD.RETAILER' | translate }} <i class="icon-required-field"></i></label>
                                    <app-custom-dropdown
                                      data-testid="retailertype"
                                      [placeholder]="'REPAIR_ADD.SELECT_A_RETAILER' | translate"
                                      optionLabel="text"
                                      optionValue="id"
                                      [isMultiselect]="false"
                                      [showSelectionChips]="true"
                                      [showClear]="true"
                                      [searchMode]="'remote'"
                                      [pageSize]="combosData['retailers'].rowsPerPageOption || 5"
                                      [totalCount]="combosData['retailers'].totalRecords"
                                      [totalPages]="getComboTotalPages('retailers')"
                                      [options]="combosData['retailers'].list"
                                      formControlName="retailerId"
                                      (onLazyLoad)="onLazyLoadComboData('retailers', $event)">
                                    </app-custom-dropdown>
                                  </div>
                                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-4 col-lg-3 col-xl-3">
                                    <label data-testid="repairtype-label" class="block text-sm mb-1" for="repairTypeId">{{ 'REPAIR_ADD.REPAIR_TYPE' | translate }} <i class="icon-required-field"></i></label>
                                    <app-custom-dropdown
                                      data-testid="repairType"
                                      [placeholder]="'REPAIR_ADD.SELECT_A_REPAIR_TYPE' | translate"
                                      optionLabel="text"
                                      optionValue="id"
                                      [isMultiselect]="false"
                                      [showSelectionChips]="true"
                                      [showClear]="true"
                                      [searchMode]="'remote'"
                                      [pageSize]="combosData['repairTypes'].rowsPerPageOption || 5"
                                      [totalCount]="combosData['repairTypes'].totalRecords"
                                      [totalPages]="getComboTotalPages('repairTypes')"
                                      [options]="combosData['repairTypes'].list"
                                      formControlName="repairTypeId"
                                      (onLazyLoad)="onLazyLoadComboData('repairTypes', $event)">
                                    </app-custom-dropdown>
                                  </div>
                                  <div class="field-wr col-12 col-sm-12 ol-md-6 col-lg-4 col-xl-3">
                                    <label data-testid="repairdate-label" for="repairDate">{{ 'REPAIR_ADD.REPAIR_DATE' | translate }}</label>
                                    <p-datepicker data-testid="repairdate" formControlName="repairDate" dateFormat="dd-mm-yy" [maxDate]="currentDate" placeholder="{{ 'REPAIR_ADD.SELECT_REPAIR_DATE' | translate }}" showIcon="true" [showTime]="true" appendTo="body" inputId="repairDate" />
                                  </div>
                                  <div class="field-wr flex flex-col col-12">
                                    <label data-testid="comments-label" class="block text-sm" for="comments">{{ 'REPAIR_ADD.COMMENTS' | translate }}</label>
                                    <textarea data-testid="comments" type="text" id="comments" formControlName="comments" autocomplete="off"></textarea>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                                  <div class="flex items-center justify-end gap-3">
                                    <button data-testid="repair-btn" class="btn primary-btn" (click)="createRepair()">
                                    {{ 'REPAIR_ADD.BTN_CREATE_REPAIR' | translate }}</button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        } @else {
                          <div class="text-center">
                            <p data-testid="repair-error" class="mb-2">{{ 'REPAIR_ADD.SERIAL_NUMBER_NO_RESULTS' | translate }}</p>
                          </div>
                        }
                      </section>
                    }
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
